<se-fe-card>
  <se-fe-card-header
    seFeDataTitle="Persona Eligibility"
    seFeDataSubtitle="A persona eligibility display component"
  ></se-fe-card-header>
  <se-fe-card-content>
    <p>Use this component to display persona eligibility details from eligibility_list_ui</p>
  </se-fe-card-content>
</se-fe-card>
@for (n of models; track n) {
  <se-fe-card>
    <se-fe-card-header [seFeDataTitle]="n"></se-fe-card-header>
    <se-fe-card-content>
      <se-fe-docs-table
        [seFeDataHeaders]="headers[n]"
        [seFeDataRows]="rows[n]">
      </se-fe-docs-table>
    </se-fe-card-content>
  </se-fe-card>
}
<se-fe-card>
  <se-fe-card-header seFeDataTitle="Example Code"></se-fe-card-header>
  <se-fe-card-content>
    <se-po-persona-eligibility-example></se-po-persona-eligibility-example>
  </se-fe-card-content>
</se-fe-card>
